import type { Tutor } from '@brighterly/lib-core-types/tutor/interfaces'

import { useCommonStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

import { useTutorKanbanStore } from '../model/store'

interface ShowTutorApiOptions {
  tutorId: string | number
  onStart?: () => void
  onSuccess?: (data: Tutor) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useShowTutorApi = async (options: ShowTutorApiOptions): Promise<Tutor | null> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.show', { tutor_id: options.tutorId })

  const tutorKanbanStore = useTutorKanbanStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const tutor: Tutor = data.data.tutor

    tutorKanbanStore.setTutor(tutor)
    commonStore.setLoading(false)

    options.onSuccess?.(tutor)

    return tutor
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return null
  } finally {
    options.onFinish?.()
  }
}
